$('.block-jump-links').each(function() {

    const select = $(this).find('.jump-links-select');

    select.on('change', function() {

        const anchor = $(this).val();

        if (anchor) {
            window.location.hash = anchor;
        }

    });

});
